"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var blog_1 = require("../pages/blog");
exports.default = blog_1.default;
exports.pageQuery = "** extracted graphql fragment **";


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/templates/tags-page.tsx